module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/tomato-17a34abf.webp";